import React from "react";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";
import ReactTable from "../../components/ReactTableWrapper";
import Button from "../../components/CustomButtons/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchPlus} from "@fortawesome/free-solid-svg-icons";

let listarCursos = async (classes, tipo) => {

  let cursos = (await connection.get("curso/listagem", {tipo: tipo, disponiveis_apenas: true})).cursos;
  cursos.sort((a, b) => {
    return b.estado.code - a.estado.code;
  });

  let title = "Inscrever";
  if (cursos.length > 0)
    title += " no " + cursos[0].tipo_curso;

  window.App.openModal(<SweetAlert
    style={{width: 850}}
    title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
      <span className={classes.modalCardTitle}>{title}</span>
    </div>)}
    onCancel={() => window.App.hideModal()}
    showCancel={false}
    showConfirm={false}
    showClose
  >
    <p>Escolha um dos cursos a partir da listagem apresentada de seguida. Clique na lupa para ver mais informações sobre cada curso e proceder ao respetivo registo</p>
    <ReactTable
      data={cursos}
      minRows={1}
      columns={[
        {
          Header: "Código",
          accessor: "descricao",
          width: 120
        },
        {
          Header: "Região / Núcleo",
          Cell: (row) => row.original.regiao + ' / ' + row.original.nucleo,
          width: 210
        },
        {
          Header: "Limite dos Registos",
          accessor: "data_limite_registos",
          Cell: general.Renderers.dateRenderer,
          width: 210
        },
        {
          Header: "Inscrições Disponíveis",
          Cell: (row) => row.original.limite_inscricoes ? row.original.vagas_disponiveis_inscricao : "Sem limite",
          width: 210
        },
        {
          Header: "",
          width: 80,
          sortable: false,
          filterable: false,
          Cell: (row) => <Button
            justIcon
            round
            simple
            onClick={() => {
              window.open("/curso/" + row.original.id);
            }}
            style={{margin: 0}}
            color="info"
            className="edit"
          >
            <FontAwesomeIcon icon={faSearchPlus}/>
          </Button>
        }
      ]}
      placeholder={"Não existem cursos disponíveis para registo, entre em contacto com o chefe de agrupamento."}
      defaultPageSize={10}
      showPaginationBottom={true}
      className="-striped -highlight"
    />
  </SweetAlert>);
};

let acoes = {
  PIF: {
    ESCOLHER_EI: {
      text: "Visualizar cursos disponíveis",
      callback: async (classes, utilizador, passo_percurso) => {
        listarCursos(classes, "EI");
      }
    },
    ESCOLHER_IPE: {
      text: "Visualizar cursos disponíveis",
      callback: async (classes, utilizador, passo_percurso) => {
        listarCursos(classes, "IPE");
      }
    },
    ESCOLHER_FGPE: {
      text: "Visualizar cursos disponíveis",
      callback: async (classes, utilizador, passo_percurso) => {
        listarCursos(classes, "FGPE");
      }
    },
    ESCOLHER_EMS: {
      text: "Visualizar cursos disponíveis",
      callback: async (classes, utilizador, passo_percurso) => {
        listarCursos(classes, "EMSPIF");
      }
    },
    CONFIRMA_CONTINUIDADE: {
      text: "Formalizar Candidatura",
      callback: async (classes, utilizador, passo_percurso, done) => {
        window.App.openModal(<SweetAlert
          warning
          onConfirm={async () => {
            window.App.hideModal();
            await connection.post("dashboard/formalizar_percurso");
            general.success("Formalizou com sucesso a sua candidatura ao PIF", "Sucesso!");
            done && done();
          }}
          onCancel={() => window.App.hideModal()}
          confirmBtnText="Confirmar"
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        ><p style={{textAlign: "center"}}>Deseja formalizar a candidatura à participação no Percurso Inicial de Formação?</p></SweetAlert>);
      }
    },
    PREENCHE_DIAGNOSTICO_PDPE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pdpe?id_percurso=" + id_percurso);
      }
    },
    PREENCHE_OBJETIVOS_PDPE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pdpe?id_percurso=" + id_percurso);
      }
    },
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_dirigente?id_percurso=" + id_percurso);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_dirigente?id_percurso=" + id_percurso);
      }
    }
  },
  PGL: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_chefe_agrupamento?id_percurso=" + id_percurso);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_chefe_agrupamento?id_percurso=" + id_percurso);
      }
    }
  },
  PRA: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_regresso_ativo?id_percurso=" + id_percurso);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador, {id_percurso}) => {
        window.App.hist.push("/formulario/pfe_regresso_ativo?id_percurso=" + id_percurso);
      }
    },
    ESCOLHER_EMS: {
      text: "Visualizar cursos disponíveis",
      callback: async (classes, utilizador, passo_percurso) => {
        listarCursos(classes, "EMS");
      }
    }
  },
  PEI: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=pei`);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=pei`);
      }
    }
  },
  PEII: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peii`);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peii`);
      }
    }
  },
  PEIII: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peiii`);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peiii`);
      }
    }
  },
  PEIV: {
    PREENCHE_DIAGNOSTICO_PFE_INICIAL: {
      text: "Preencher Diagnóstico Inicial",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peiv`);
      }
    },
    PREENCHE_OBJETIVOS_PFE: {
      text: "Preencher Objetivos",
      callback: async (classes, utilizador) => {
        window.App.hist.push(`/formulario/pfe_educadores?utilizador=${utilizador.id}&grupo_fluxo=peiv`);
      }
    }
  }
};

export default acoes;